<template>
  <!-- eslint-disable -->
  <marker
    id="head"
    viewBox="0 0 10 10"
    :refX="ref_x"
    :refY="ref_y"
    markerWidth="6"
    markerHeight="6"
    orient="auto"
  >
    <path
      d="M9.21114 4.10549C9.94819 4.47401 9.9482 5.52581 9.21115 5.89434L2.09712 9.45141C1.20023 9.89987 0.274973 8.89626 0.794702 8.03869L2.32225 5.51821C2.51531 5.19964 2.51531 4.80017 2.32224 4.4816L0.794749 1.96129C0.275008 1.10373 1.20025 0.100105 2.09715 0.54855L9.21114 4.10549Z"
      fill="#7F92A9"
    />
  </marker>
  <!-- eslint-enable -->
</template>

<script>
  export default {
    props: {
      ref_x: {
        type: [Number, String],
        default: 14
      },

      ref_y: {
        type: [Number, String],
        default: 5
      }
    }
  };
</script>
